var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReservedIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56.943 62.03",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".reserved_icon_svg__a,.reserved_icon_svg__b{fill:none;stroke:inherit;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}.reserved_icon_svg__a{fill-rule:evenodd}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-svg-primary": "stroke"
  }, /*#__PURE__*/React.createElement("path", {
    className: "reserved_icon_svg__a",
    d: "M37.661 61.03v-4.967a2.707 2.707 0 012.707-2.7s5.031-.221 6.333-.7c2.574-.964 3.027-2.144 3.155-4.491a42.013 42.013 0 00-.372-7.233l5.171-2.394a2.243 2.243 0 00.964-3.166s-5.653-7.028-5.978-10.016A24.321 24.321 0 105.753 39.795c4.427 5.984 6.484 10.272 6.484 21.235"
  }), /*#__PURE__*/React.createElement("path", {
    className: "reserved_icon_svg__b",
    d: "M15.601 10.903h22.256a1.06 1.06 0 01.744.3 1.019 1.019 0 01.307.73v12.779a1.019 1.019 0 01-.307.73 1.06 1.06 0 01-.744.3h-3.884v5.287l-5.361-5.256v-.03H15.601a1.042 1.042 0 01-1.052-1.031V11.934a1.042 1.042 0 011.052-1.031z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReservedIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/reserved_icon.932451fdf2ad424674c080e0498d6689.svg";